import React, { useState, useEffect } from 'react'
import CloseSVG from '../../../../assets/svg/close.svg'
import Modal from '../../modal'
import Button from '../../../button'

const ViewAttachment = ({ reimbursement, isOpen, closeModal }) => {
  const fileUrl = reimbursement?.file_url || ''

  const handleDownload = () => {
    if (!fileUrl) return

    const link = document.createElement('a')
    link.href = fileUrl
    link.download = fileUrl.split('/').pop() || 'attachment'
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
  }
  const [pdf, setPdf] = useState('')

  useEffect(() => {
    if (reimbursement) {
      setPdf(reimbursement.file_url)
    }
  }, [reimbursement])

  return (
    <Modal
      scrollable={true}
      className='!min-w-[70%] !rounded-none !min-h-screen'
      isOpen={isOpen}
      centered={true}
    >
      <div className='pl-8 pr-8 pt-4'>
        <div className='flex flex-row justify-between items-center'>
          <span className='header-4'>Attachment</span>
          <Button
            text='Download'
            type='button'
            theme={'primary'}
            leftIcon={'view'}
            className='flex gap-2 !h-[35px] md:w-fit w-full px-2 items-center'
            textClass={'!text-[11px]'}
            disabled={!fileUrl}
            onClick={handleDownload}
          />
          <div className='cursor-pointer' onClick={() => closeModal()}>
            <img src={CloseSVG} alt='close' />
          </div>
        </div>
      </div>
      <hr className='divider mt-2' />
      <div className='flex flex-col items-center justify-center pb-4 overflow-auto header-4 !min-h-screen'>
        {pdf ? (
          <object data={pdf} type='application/pdf' width='80%' height='2000px'>
            <p>
              <a href={pdf}>Download Attachment</a>
            </p>
          </object>
        ) : (
          <div>No PDF Specified</div>
        )}
      </div>
    </Modal>
  )
}

export default ViewAttachment
